export { AdvertisingEntity } from './advertising';
